// src/pages/TransferPendingRecord/index.js
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined,   QuestionCircleOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography,Drawer, Tooltip } from "antd";
import TransferPendingRecordFilters from "./components/TransferPendingRecordFilters";
import TransferPendingRecordTable from "./components/TransferPendingRecordTable";
import { fetchTransferPendingRecord } from "./TransferPendingRecordThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const TransferPendingRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();

  

  const { filters, list } = useSelector((state) => state.transferPendingRecord);
  const reportRef = useRef(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Transfer Pending Report",
    removeAfterPrint: true,
  });

  const handleNavigateToBack = () => {
    navigate(-1);
  }

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          // title={<div style={{ display: "flex", alignItems: "center" }}>
          //   <Button
          //     type="text"
          //     icon={<ArrowLeftOutlined />}
          //     onClick={handleNavigateToBack}
          //     style={{ marginRight: 8 }}
          //   /><Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Transfer Pending Record</Title>
          //   </div>}
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToBack}
                style={{ marginRight: 8 }}
              />

              <Title
                level={4}
                style={{ margin: 0 }}
                className="reportBigTitle"
              >
                Transfer Pending Record
              </Title>

              <div style={{ marginLeft: "auto" }}>
                <Tooltip title="Help">
                  <Button
                    type="text"
                    icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                    onClick={() => setHelpOpen(true)}
                  />
                </Tooltip>
              </div>
            </div>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <TransferPendingRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <TransferPendingRecordTable />
        </Card>
      </App>
      <Drawer
        title="Transfer Pending Report Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Transfer Pending Report
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Transfer Pending Report module is used to monitor pending
            inventory transfer transactions between branches or warehouse
            locations within the ERP system.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to View Pending Transfers</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Transfer Pending Report</strong></li>
              <li>Select required filters and date range</li>
              <li>Review pending transfer entries</li>
              <li>Verify branch and stock transfer details</li>
              <li>Check pending quantities and statuses</li>
              <li>Analyze incomplete transfer transactions</li>
              <li>Use Print option to generate report copy if needed</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Pending records indicate incomplete stock transfers.</li>
              <li>Filters can be used to narrow report results.</li>
              <li>Printed reports reflect current pending transfer data.</li>
              <li>Transfer monitoring helps maintain inventory accuracy.</li>
            </ul>
          </div>
        </div>
      </Drawer>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Transfer Pending Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <TransferPendingRecordTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default TransferPendingRecord;
